module.exports = __webpack_public_path__ + "static/media/boolean_widget.d15326d4.jpg";